import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import CardProfile from '../../../components/Profile/Card/';
import { responseTimeInCommunity } from '../../../store/actions/UserAction';
import './ResponseTime.scss';

const ResponseTime = ({
  authClient,
  responseTime,
  responseTimeInCommunity,
}) => {

  const [didCheck, setDidCheck] = useState(false)

  useEffect(() => {
    if (!didCheck) {
      try {        
        responseTimeInCommunity(authClient.uid)
        setDidCheck(true)
      } catch (error) {
        console.log('error', error);
      }
    }
  }, [
    authClient.uid,
    didCheck,
    responseTimeInCommunity
  ])

  return (
    <>
    <div className="ResponseTime">
      <CardProfile
        title={'Tiempo de respuesta en comunidad'}
        subTitle={
          'Entre más rápido respondas más clientes puedes obtener.'}
        awardIcon
        status={
          authClient && responseTime && responseTime === 'fast' ?
          true : false
        }
      >
        <div>
          <p className="ResponseTime_title">El tiempo que tardas en responder a los clientes genera un status en tu perfil.</p>
          <div className="ResponseTime_contentContainer">
            <div className="ResponseTime_levelContainer">
              {responseTime === 'fast' ?
                <>
                  <img src='/img/responseTime/fast-response.svg' alt="responseLevel" className="ResponseTime_fastImg" />
                  <p className="ResponseTime_fastLevel">Nivel de respuesta <b>ALTO</b></p>
                </> :
              responseTime === 'mid' ?
                <>
                  <img src='/img/responseTime/normal-response.svg' alt="responseLevel" className="ResponseTime_normalImg" />
                  <p className="ResponseTime_normalLevel">Nivel de respuesta <b>MEDIO</b></p>
                </> :
              responseTime === 'low' ?
                <>
                  <img src='/img/responseTime/slow-response.svg' alt="responseLevel" className="ResponseTime_slowImg" />
                  <p className="ResponseTime_slowLevel">Nivel de respuesta <b>BAJO</b></p>
                </> :
                <>
                  <img src='/img/responseTime/null-response.svg' alt="responseLevel" className="ResponseTime_nullImg" />
                  <p className="ResponseTime_nullLevel">Nivel de respuesta</p>
                </>
              }
            </div>
            <p className="ResponseTime_explanation">
              El tiempo promedio de respuesta es <b>24 horas</b>, <br className='ResponseTime_br'/>
              si tardas más de eso te arriesgas a perder clientes.
            </p>
          </div>
        </div>
      </CardProfile>
    </div>
    </>
  );
};

const mapStateToProps = state => ({
  authClient: state.authClient,
  listQuestion: state.communityReducer.listQuestions,
  answers: state.communityReducer.moreAnswers,
  responseTime: state.authClient.responseTime
});

const mapDispatchToProps = dispatch => ({
  responseTimeInCommunity: lawyerUid => dispatch(responseTimeInCommunity(lawyerUid))
})

export default connect(mapStateToProps, mapDispatchToProps)(ResponseTime);
